import { Model } from 'pinia-orm';
import { BelongsTo, Num, Str } from 'pinia-orm/dist/decorators';
import Package from './Package';

export default class PackageProcurementStep extends Model {
  static entity = 'App\\Models\\PackageProcurementStep';

  @Num(0)
  declare id: number;
  @Num(0)
  declare package_id: number;
  @Str('')
  declare name: string;
  @Num(0)
  declare lead_time_weeks: number;
  @Str(undefined)
  declare actual_date: string | undefined;
  @Num(0)
  declare sort_order: number;
  @Str('')
  declare created_at: string;
  @Str('')
  declare updated_at: string;

  @BelongsTo(() => Package, 'package_id', 'id')
  declare package: Package;
}
